import React from 'react';
import { palette } from '../../styles/theme';

export function UploadSVG ({ customStroke, className = '', selected = false }) {
    const stroke = customStroke || palette.icons;
    return (
        <svg className={`svg-icon svg-icon${selected && '-primary'} svg-icon-2x`} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ marginBottom: '6px' }}>
            <g clipPath="url(#clip0_6255_14304)">
                <path d="M12 4L7 9M12 4L17 9" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 4V16" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6255_14304">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}
